module.exports = __webpack_public_path__ + "static/img/products application_Clear PVC1.b3573baf.jpg";